import React, { useEffect, useRef } from "react";
import "./PerformanceDashboardScreen.css";
import { useNavigate } from "react-router-dom";
import { GoChevronRight, GoArrowLeft } from "react-icons/go";
import Navbar from "../../../common/components/HeaderOpsPage/Navbar";
import Body from "../../../common/components/Body/Body";
import * as powerbi from "powerbi-client";

const PerformanceDashboardScreen = () => {
  const navigate = useNavigate();

  const powerbiServiceRef = useRef(null);
  const reportRef = useRef(null); // ✅ store report instance

  const url = process.env.REACT_APP_POWERBI_PERFORMANCE;
  console.log("API URL:", url);

  useEffect(() => {
    let interval;

    // Initialize PowerBI service
    if (!powerbiServiceRef.current) {
      powerbiServiceRef.current = new powerbi.service.Service(
        powerbi.factories.hpmFactory,
        powerbi.factories.wpmpFactory,
        powerbi.factories.routerFactory
      );
    }

    loadPowerBI();
    console.log("dashboard token refreshed");
    // ✅ Refresh token every 50 minutes
    interval = setInterval(() => {
      refreshToken();
    }, 30 * 60 * 1000);

    return () => {
      clearInterval(interval);

      const container = document.getElementById("powerbiContainer");
      if (container && powerbiServiceRef.current) {
        powerbiServiceRef.current.reset(container);
      }
    };
  }, []);

  // ✅ Load report initially
  const loadPowerBI = async () => {
    try {
      const response = await fetch(url);
      const data = await response.json();

      const embedConfig = {
        type: "report",
        id: data.reportId,
        embedUrl: data.embedUrl,
        accessToken: data.embedToken,
        tokenType: powerbi.models.TokenType.Embed,
        settings: {
          panes: {
            filters: { visible: false },
            pageNavigation: { visible: true }
          }
        }
      };

      const container = document.getElementById("powerbiContainer");

      if (container && powerbiServiceRef.current) {
        powerbiServiceRef.current.reset(container);

        // ✅ Embed and store report instance
        const report = powerbiServiceRef.current.embed(container, embedConfig);
        reportRef.current = report;

        // ✅ Handle token expiry errors
        report.on("error", async (event) => {
          console.log("PowerBI Error:", event.detail);

          if (event.detail?.message?.includes("TokenExpired")) {
            console.log("⚠️ Token expired, refreshing...");
            await refreshToken();
          }
        });
      }
    } catch (err) {
      console.error("❌ PowerBI load error:", err);
    }
  };

  // ✅ Refresh token without reload
  const refreshToken = async () => {
    try {
      const response = await fetch(url);
      const data = await response.json();

      if (reportRef.current) {
        await reportRef.current.setAccessToken(data.embedToken);
        console.log("✅ Token refreshed successfully");
      }
    } catch (err) {
      console.error("❌ Token refresh failed:", err);
    }
  };

  return (
    <>
      <Navbar />
      <Body className={"wrapper"}>
        <div className="dashboard-main--container main-component-container">

          <div className="row">
            <div className="col-6">
              <p className="insight-breadCrum m-0">
                <GoArrowLeft
                  className="buttonFeature pb-1"
                  size={22}
                  onClick={() => navigate("/landing")}
                />
                <span onClick={() => navigate("/landing")}>Home</span>
                <GoChevronRight size={18} />
                <span>
                  <u>Performance-Dashboard</u>
                </span>
              </p>
            </div>
          </div>

          <div
            id="powerbiContainer"
            style={{ width: "100%", height: "80vh", marginTop: "20px" }}
          ></div>

        </div>
      </Body>
    </>
  );
};

export default PerformanceDashboardScreen;